import { MenuItem } from "../../Types/Layout";
import {
  CareerManagementRoute,
  ContentManagementRoute,
  DashboardRoute,
  PaymentManagementRoute,
  ProductManagementRoute,
  ProductRequestManagementRoute,
  ReviewManagementRoute,
  ServiceManagementRoute,
  ServiceRequestManagementRoute,
  UserManagementRoute,
} from "../../utils/Constant";

export const MenuList: MenuItem[] = [
  {
    id: 1,
    title: "",
    lanClass: "lan-1",
    Items: [
      // {
      //   id: 1,
      //   title: "Dashboards",
      //   type: "link",
      //   lanClass: "lan-3",
      //   path: `/${DashboardRoute}`,
      // },
      {
        id: 2,
        title: "Request Management",
        // icon: "layout",
        type: "sub",
        lanClass: "lan-3",
        active: false,
        children: [
          {
            title: "Service Requests",
            type: "link",
            path: `/${ServiceRequestManagementRoute}`,
          },
          {
            title: "Product Requests",
            type: "link",
            path: `/${ProductRequestManagementRoute}`,
          },
        ],
      },
      {
        id: 3,
        title: "User Management",
        // icon: "layout",
        type: "link",
        lanClass: "lan-3",
        path: `/${UserManagementRoute}`,
      },
      // {
      //   id: 4,
      //   title: "Service Management",
      //   // icon: "layout",
      //   type: "link",
      //   lanClass: "lan-3",
      //   path: `/${ServiceManagementRoute}`,
      // },
      // {
      //   id: 5,
      //   title: "Career Management",
      //   // icon: "layout",
      //   type: "link",
      //   lanClass: "lan-3",
      //   path: `/${CareerManagementRoute}`,
      // },
      // {
      //   id: 6,
      //   title: "Product Management",
      //   // icon: "layout",
      //   type: "link",
      //   lanClass: "lan-3",
      //   path: `/${ProductManagementRoute}`,
      // },
      {
        id: 7,
        title: "Payment Management",
        // icon: "layout",
        type: "link",
        lanClass: "lan-3",
        path: `/${PaymentManagementRoute}`,
      },
      // {
      //   id: 8,
      //   title: "Review Management",
      //   // icon: "layout",
      //   type: "link",
      //   lanClass: "lan-3",
      //   path: `/${ReviewManagementRoute}`,
      // },
      // {
      //   id: 9,
      //   title: "Content Management",
      //   // icon: "layout",
      //   type: "link",
      //   lanClass: "lan-3",
      //   path: `/${ContentManagementRoute}`,
      // },
    ],
  },
];
